import { parseISO } from 'date-fns';

export const handleUsingParseIso = (isIsoParsed: boolean, value: string) => {
  if (isIsoParsed && value) {
    return parseISO(value);
  }
  return value;
};
